import load from 'load-script'

import Platform from '../Platform'
import { placeImage } from './helpers'

export default class App extends Platform {
  constructor () {
    super({
      clientId: process.env.VUE_APP_CLIENT_ID,
      clientSecret: process.env.VUE_APP_CLIENT_SECRET,
      vectorFormat: 'emf',
      features: {
        prototype: false,
        vector: false
      }
    })
  }

  init () {
    // Add Office.js Script for accessing Office APIs
    let url = 'https://appsforoffice.microsoft.com/lib/1/hosted/Office.js'
    let self = this

    load(url, () => {
      console.log('Office APIs Loaded successfully.')
      self.vector_supported = false
      window.Office.initialize = function () {
        window.Office = window.Office
        // Set Platform
        self.platform = 'office-' + window.Office.context.host.toLocaleLowerCase()
        self.info = window.Office.context.diagnostics
        // Check if the platform is Office Online then vector files are not supported
        if (window.Office.context.platform === window.Office.PlatformType.OfficeOnline) {
          // self.features.vector = false
          console.log('Vector Support: false')
        }

        // Load Plugin Settings and log into Analytics
        if (window.loadPlugin) {
          window.loadPlugin()
        }
      }
    })
  }

  insertItem (file) {
    placeImage(file)
  }

  openURL (url) {
    window.open(url)
  }
}
